export default __webpack_public_path__ + "static/media/ozp-trans-blacktext-medium.027a5ab4.png";